import { render, staticRenderFns } from "./personality-test.vue?vue&type=template&id=1b9e6912&scoped=true&"
import script from "./personality-test.vue?vue&type=script&lang=js&"
export * from "./personality-test.vue?vue&type=script&lang=js&"
import style0 from "./personality-test.vue?vue&type=style&index=0&id=1b9e6912&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9e6912",
  null
  
)

export default component.exports